<template>
    <div class="ur-data-grid__header__freeze-wrapper" :style="freezeStyle" ref="freezeHeader">
        <slot>
            <check-cell  v-if="gridInfo.opts.selectCheck"/>
            <header-cell :field="f" v-for="(f,idx) in gridInfo.freezeCols" :key="f.value+'_'+idx"/>
            <header-cell v-if="gridInfo.opts.accordion" :width="gridInfo.opts.accordionColumnWidth"/>
        </slot>
    </div>
</template>

<script>
import headerCell from "./urDataGridHeaderCell";
import checkCell  from "./urDataGridHeaderCheckCell";
export default {
    name : 'urDataGridFeaderRow',
    inject : ['gridInfo'],
    components : {headerCell, checkCell},
    props: {rowCnt : {type:Number, default:1}},
    computed: {
        freezeWidth() {return this.gridInfo.vars_freezeWidth},
        freezeStyle() {
            var height = this.gridInfo.opts.headerHeight;
            if(this.rowCnt) height *= this.rowCnt;
            height+=2; // for border top/bot
            return {
                "height": `${height}px`,
                "width" : `${this.freezeWidth}px`,
            }
        },
    },
    mounted() {
        this.gridInfo.func.setRefs('freezeHeader',this.$refs.freezeHeader);
    },
}
</script>